import { FC } from 'react';
import { CalculatorHeading } from '../CalculatorHeading';
import { CalculatorText } from '../CalculatorText';
import { CalculatorFormControlProps } from './types';
import { FormControl } from '../FormControl';

export const CalculatorFormControl: FC<CalculatorFormControlProps> = ({
  name,
  textKey,
  titleKey,
  rules,
  className,
  radioOptions,
  isWide,
}) => {
  return (
    <div className={className}>
      <CalculatorHeading labelKey={titleKey} />
      {textKey && <CalculatorText labelKey={textKey} />}
      <FormControl isWide={isWide} name={name} className={'mt-2'} radioOptions={radioOptions} rules={rules} />
    </div>
  );
};
